import { render, staticRenderFns } from "./TaskDocumentTemplate.vue?vue&type=template&id=7aa4f2a6&scoped=true&lang=pug"
import script from "./TaskDocumentTemplate.vue?vue&type=script&lang=ts"
export * from "./TaskDocumentTemplate.vue?vue&type=script&lang=ts"
import style0 from "./TaskDocumentTemplate.vue?vue&type=style&index=0&id=7aa4f2a6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa4f2a6",
  null
  
)

export default component.exports